import pug from 'javascripts/work_tags/templates/hover_popover_content.jst.pug';
window.JST = window.JST || {};
window.JST['work_tags/templates/hover_popover_content'] = pug;
